import React, { ReactElement, useEffect, useState } from 'react';
import { CognitoUser } from '@aws-amplify/auth';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { setAuthCookies, checkAuthCookies } from '../../utils/cookies-management';
import { getProfile } from '../../utils/auth-functions';
import { getUserPackages, Package } from '../../utils/user-packages';
import CardHeader from '../organisms/CardHeader';

export interface CognitoUserAttributes {
  name?: string,
  family_name?: string,
  nickname?: string,
  email?: string
}

type CustomCognitoUser = CognitoUser & { attributes: CognitoUserAttributes };

export default function Subscriptions(): ReactElement {
  const [profile, setProfile] = useState<CustomCognitoUser | string | undefined>(undefined);
  const [packages, setPackages] = useState<Package[] | undefined>(undefined);

  const history = useHistory();
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  /* const redirectUrl = queryString.get('redirectUrl'); */
  const inApp = queryString.get('inApp');
  console.log('inApp', inApp);

  useEffect(() => {
    const getProfileData = async () => {
      await getProfile()
        .then((res) => setProfile(res));
    };
    getProfileData();
  }, []);

  const dateFormatter = (date: string): string => {
    const jsDate = new Date(date.replace(/-/g, '/'));
    const day = jsDate.getDate() < 9 ? `0${jsDate.getDate()}` : jsDate.getDate();
    const month = jsDate.getMonth() < 9 ? `0${jsDate.getMonth() + 1}` : jsDate.getMonth() + 1;
    const year = jsDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    if (!checkAuthCookies() && profile &&  typeof profile !== 'string') {
      const jwtToken = profile.getSignInUserSession()?.getIdToken().getJwtToken();
      const expiration = profile.getSignInUserSession()?.getAccessToken().getExpiration();
      const refreshToken = profile.getSignInUserSession()?.getRefreshToken().getToken();
      const tokens = {
        idToken: {
          jwtToken: jwtToken || '',
        },
        accessToken: {
          jwtToken: jwtToken || '',
          payload: {
            exp: expiration || 9999999999,
          },
        },
        refreshToken: refreshToken,
      };
      if (jwtToken) setAuthCookies(tokens);
    }
    if (profile && profile === 'The user is not authenticated') {
      history.replace(inApp === 'true' ? '/?inApp=true' : '/');
    } else if (profile && typeof profile !== 'string') {
      const accessToken = profile.getSignInUserSession()?.getAccessToken().getJwtToken();
      const getPackages = async () => {
        try {
          const userPackagesResponse = await getUserPackages(accessToken || '');          
          if (userPackagesResponse && userPackagesResponse.result) {
            const { 
              result: {
                data: { user_packages: userPackages },
              },
            } = userPackagesResponse;            
            setPackages(userPackages);
          }
        } catch (error) {
          console.log('error', error);
        }
      };
      getPackages();
    }
  }, [profile]);

  console.log('packages', packages);

  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h5 className="card-title text-center py-1">
                Abbonamenti attivi
              </h5>
              <p className="card-text">
                Verifica i tuoi abbonamenti attivi
              </p>
              <div className="form-group mb-5 mt-5 d-flex align-items-center justify-content-around">
                <table className="mb-5">
                  <thead>
                    <tr className="d-none d-md-table-row">
                      <th>ORDINE</th><th>PRODOTTO</th>
                      <th>ACQUISTO</th><th>INIZIO</th><th>FINE</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    packages && (
                      packages.map((userPackage, index) => {
                        console.log('dateFormatter(userPackage.start_date)', dateFormatter(userPackage.start_date));
                        console.log('dateFormatter(userPackage.start_date)', dateFormatter(userPackage.end_date));
                        console.log('dateFormatter(userPackage.start_date)', dateFormatter(userPackage.created_at));
                        
                        return (
                          <tr key={`UserPackage-${userPackage.id}`}>
                            <td className="d-none d-md-table-cell">{userPackage.order_id}</td>
                            <td className="d-none d-md-table-cell">{userPackage.title}</td>
                            <td className="d-none d-md-table-cell">{dateFormatter(userPackage.created_at)}</td>
                            <td className="d-none d-md-table-cell">{dateFormatter(userPackage.start_date)}</td>
                            <td className="d-none d-md-table-cell">{dateFormatter(userPackage.end_date)}</td>

                            <tr className="d-md-none product-number">
                              <td className="pb-4">Acquisto N°: {index + 1}</td>
                            </tr>

                            <tr><td className="d-md-none d-flex justify-content-between w-100"><span>ORDINE: </span><span>{userPackage.order_id}</span></td></tr>
                            <tr><td className="d-md-none d-flex justify-content-between w-100"><span>PRODOTTO: </span><span>{userPackage.title}</span></td></tr>
                            <tr><td className="d-md-none d-flex justify-content-between w-100"><span>ACQUISTO: </span><span>{dateFormatter(userPackage.created_at)}</span></td></tr>
                            <tr><td className="d-md-none d-flex justify-content-between w-100"><span>INIZIO: </span><span>{dateFormatter(userPackage.start_date)}</span></td></tr>
                            <tr><td className="d-md-none d-flex justify-content-between w-100 pb-4"><span>FINE: </span><span>{dateFormatter(userPackage.end_date)}</span></td></tr>
                          </tr>
                        );
                      }))
                  }
                  </tbody>
                </table>
              </div>
              <div className="d-flex align-items-center flex-column">
                <Link className="link-override" to={inApp === 'true' ? '/profile?inApp=true' : '/profile'}>
                  Oppure torna indietro
              </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}